import Icon from "@vfuk/core-icon";
import { useUserManagementStore } from "src/hooks/stores";
import { useNavigate } from "react-router-dom";
import { RoundedPillStyles, TableRow, Tooltip } from "@ucchub/ui";
import type { UserTypes } from "@hub/common-libs";
import type { User } from "src/interfaces/user";
import { UserRoles } from "./UserRowStyles";
import Pill from "@vfuk/core-pill";

type UserRowProps = {
  user: User;
  userActions: UserTypes.actionsResponse;
  isVfAdmin: boolean;
};

const UserRow = ({
  user,
  userActions,
  isVfAdmin,
}: UserRowProps): JSX.Element => {
  const navigate = useNavigate();

  const addSelectedUser = useUserManagementStore(
    (state) => state.addSelectedUser
  );

  const selectedUserId: string = user.userId as string;

  const clearAllSelectedUsers = useUserManagementStore(
    (state) => state.clearAllSelectedUsers
  );

  const redirectToView = (userId: string) => {
    navigate("/users/" + encodeURIComponent(userId));
    clearAllSelectedUsers();
    addSelectedUser(user);
  };

  // Capitalize first character of of the status string
  const userStatus = user.status.charAt(0).toUpperCase() + user.status.slice(1);

  const rowDataPreparation = () => {
    const rowData: React.ReactNode[] = [
      user.email,
      user.firstName && user.lastName
        ? `${user.firstName}, ${user.lastName}`
        : "",
      user.status && (
        <RoundedPillStyles
          state={userStatus === "Active" ? "success" : "error"}
        >
          <Pill text={userStatus} />
        </RoundedPillStyles>
      ),
      <UserRoles key={user.userId}>{user.role.roleName}</UserRoles>,
    ];
    if (isVfAdmin) rowData.splice(2, 0, user.organisation?.orgName || "");
    return rowData;
  };

  return (
    <>
      <TableRow
        rowData={rowDataPreparation()}
        canViewIcon={true}
        onIconClick={() => redirectToView(selectedUserId)}
        isIconDisabled={false} //view button should always be enabled regarding of any permission - as per Amol/Himansu
        icon={
          userActions.view && (
            <Tooltip content={userActions.view.label || ""}>
              <span>
                <Icon
                  name={userActions.view.icon || ""}
                  appearance="secondary"
                  size={3}
                />
              </span>
            </Tooltip>
          )
        }
      />
    </>
  );
};

export default UserRow;
